import { CARD_FORM } from '../form-card-type';
import { showToast } from '../../../toasts';
import useAuth from '../../../../hooks/auth-hooks';
import { checkForSelectValue } from '../../form-helpers';

import { updateCard } from '../../../../routes/update-card';

/**
 * Function to update an existing card
 * 
 * @returns void
 */
export const updateExistingCard = () => {
  const { cardForm, cardCustomer, cardCardGroup, cardSubmitButton, cardNumber, cardStatus } = CARD_FORM;

  const validateForm = () => {
    cardForm.classList.add('was-validated');

    checkForSelectValue(cardCustomer, 'Customer', 'customer');
    checkForSelectValue(cardCardGroup, 'Card Group', 'card-group');

    return cardForm.checkValidity() &&
        cardCustomer.getAttribute('data-value') != null &&
        cardCardGroup.getAttribute('data-value') != null;
  };

  const postData = async (awsData: any) => {
    const { body } = await updateCard(awsData);

    if ( body ) {
      showToast('aafp_toast', `Card has been updated.`);
      setTimeout(() => {
        location.reload();
      }, 1500);
    }
  }

  cardForm.addEventListener('submit', async (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    if ( validateForm() ) {
      cardForm.classList.remove('form-control:valid');
      cardSubmitButton.classList.add('aafp_button-loading');

      const { userId } = useAuth()!;

      const awsData = {
        wpId: +userId,
        cardNumber: cardNumber.value, 
        cardGroupId: +cardCardGroup.getAttribute('data-value')!,
        cardStatus: +cardStatus.getAttribute('data-value')!
      };

      postData(awsData);      
    } 
  });
};